import {css} from 'lit';

export const style = css`

  :host {
    --annotation-color: var(--_annotation-color, var(--sbkAnnotationFgColorOnLightEnabled));
    --annotation-color-error: var(--_annotation-color-error, var(--sbkAnnotationFgColorOnLightError));
    --annotation-color-disabled: var(--_annotation-color-disabled, var(--sbkAnnotationFgColorOnLightDisabled));

      display: block;
  }

    * {
    box-sizing: border-box;
  }

    ::slotted(*) {
        margin: 0;
    }

    .annotation {
      display: flex;
      color: var(--annotation-color);
      margin-top: var(--sbkInput3xs);
    }

    .annotation-error {
        color: var(--annotation-color-error);
    }

    .annotation-disabled {
        color: var(--annotation-color-disabled);
    }

    .annotation__text {
        font: var(--sbkAnnotationTypographyLabel);
        max-width: var(--sbkCoreContentAreaBodyMaxWidth);
        padding: var(--sbkCoreSpacing5xs) var(--sbkAnnotationSpacing4xs);
    }

`;
